export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_fragment_6.333f5605.jpg";